export const businessIntelligence = {
  conformity_heatmap: {
    title: "Mapa de calor de conformidad",
    description:
      "Mapa de calor interactivo que muestra los niveles de conformidad agregados en todos los sitios y temas",
    loading_error: "Error al cargar los datos de conformidad. Por favor, inténtelo de nuevo.",
    stats: {
      total_tasks: "Tareas totales",
      sites_with_data: "Sitios con datos",
      themes_with_data: "Temas con datos",
    },
    filters: {
      title: "Filtros",
      year: "Año",
      all_years: "Todos los años",
      site: "Sitio",
      all_sites: "Todos los sitios",
      theme: "Tema",
      all_themes: "Todos los temas",
      standard: "Norma",
      all_standards: "Todas las normas",
      assessment: "Evaluación",
      all_assessments: "Todas las evaluaciones",
      clear_all: "Limpiar todo",
    },
    legend: {
      does_not_meet: "No cumple",
      partially_meets: "Cumple parcialmente",
      substantially_meets: "Cumple sustancialmente",
      fully_meets: "Cumple totalmente",
      no_scorable_data: "Sin datos puntuables",
    },
    axis_labels: {
      sites: "Sitios",
      themes: "Temas",
    },
    avg_conformity_level: "Nivel de conformidad promedio",
    no_data_message:
      "No hay datos disponibles para los filtros seleccionados. Intente ajustar sus criterios de filtro.",
  },
};
